/**
 * SafetyCheck
 * The SafetyCheck API
 *
 * The version of the OpenAPI document: master-35d84d79-917289
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AreYouOkResponseDto { 
    response: AreYouOkResponseDtoResponse;
    pendingUntil?: string;
}
export enum AreYouOkResponseDtoResponse {
    Ok = 'ok',
    NeedSupport = 'need-support'
};



